import { CoreIcon } from '../core-icon';
import qrcodeSVG from '../../assets/icons/qrcode.svg';
import type { IconProps } from '../core-icon';

export const QrcodeIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={qrcodeSVG} {...props} />;
};
